// import { Report55Container } from "../../../containers/SupportSystem/Reports/Report55Container";
import { ListReportSupportRequestContainer } from "../../../containers/SupportSystem/Reports/ListReportSupportRequestContainer";
export function ListReportSupportRequestPage() {
    return (
        <ListReportSupportRequestContainer />
    );

}